module.exports = Backbone.Collection.extend({
    url: function() {
        if (this.wellboreId){
            return `./api/wellbore/${this.wellboreId}/rights`;
        }
        else {
            return `./api/entry/${this.entryId}/rights`;
        }
    },
    initialize: function(models, options) {
        options = options || {};
        this.wellboreId = options.wellboreId;
        this.entryId = options.entryId;
    }
});
